

import GeneralToleranceWidget from "./General";
import "@iframe-resizer/child";

export const GeneralToleranceWidgetPage = () => {
  return <GeneralToleranceWidget />;
};

export default GeneralToleranceWidgetPage;
